<template>
  <div class="px-0 w-100">
    <div class="header d-flex justify-content-between i-mb-10">
      <div>
        <h5
          class="d-flex flex-row align-items-center justify-content-center i-text-heading-5 i-text-neutral-120 i-mb-2"
        >
          <span>Fraud Detectors</span>
          <help-tooltip
            class="ml-2"
            text="Inscribe's core fraud detection tools. To improve your experience they can be enabled or disabled to your preference but we strongly recommend leaving them enabled"
          />
        </h5>
        <p class="i-text-body-2 i-text-neutral-110">Manage fraud detectors</p>
      </div>
      <div class="d-flex align-items-center">
        <i-button
          text="Save"
          data-testid="save-rules-button"
          size="md"
          @button-click="saveRules()"
        ></i-button>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div
        v-if="rulesSchema.variables"
        class="pb-4 mb-4 align-items-start rules-list"
      >
        <div class="d-flex flex-column w-100" data-testid="default-rules">
          <rule
            v-for="rule in detectors"
            :key="rule.name"
            :rule="rule"
            :is-simple-detector-rule="true"
          />
        </div>
      </div>
      <i-spinner v-else size="sm" class="mx-auto my-5"></i-spinner>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { HelpTooltip } from '@inscribe/ui-kit';
import { iButton, iSpinner } from '@inscribe/signal';
import Rule from '@/V2/decision-engine/Rule';
import RuleEngine from '@/utils/ruleEngine';

export default {
  components: {
    'help-tooltip': HelpTooltip,
    iButton,
    iSpinner,
    rule: Rule,
  },
  data() {
    return {
      showNewRuleModal: false,
      newRule: null,
      ruleError: null,
      mode: '',
    };
  },
  computed: {
    ...mapGetters({
      rules: 'getRules',
      rulesSchema: 'getRulesSchema',
      isOrgAdmin: 'isOrgAdmin',
    }),

    detectors() {
      return this.rules.filter(
        (r) => r.default && RuleEngine.isSimpleDetectorRule(r),
      );
    },
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.getConfigRules();
    }
  },
  methods: {
    ...mapActions({
      getConfigRules: 'getConfigRules',
    }),

    saveRules() {
      this.$emit('save-rules', this.detectors);
    },
  },
};
</script>
